import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ProductReference } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomProductActions } from '../store/actions';
import { StateWithProduct } from '../store/product-state';
import { ProductSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupReferencesFacade {
  constructor(private store: Store<StateWithProduct>) {}

  loadProducts(productCode: string, referenceType: string, categoryCode: string, pageSize: number): void {
    this.store.dispatch(
      new CustomProductActions.LoadProductGroupReferences(productCode, referenceType, categoryCode, pageSize),
    );
  }

  getProducts(productCode: string, referenceType: string, categoryCode: string): Observable<ProductReference[]> {
    return this.store.pipe(
      select(ProductSelectors.getProductGroupReferencesValue(productCode, referenceType, categoryCode)),
    );
  }

  getProductsLoading(productCode: string, referenceType: string, categoryCode: string): Observable<boolean> {
    return this.store.pipe(
      select(ProductSelectors.getProductGroupReferencesLoading(productCode, referenceType, categoryCode)),
    );
  }

  getProductsSuccess(productCode: string, referenceType: string, categoryCode: string): Observable<boolean> {
    return this.store.pipe(
      select(ProductSelectors.getProductGroupReferencesSuccess(productCode, referenceType, categoryCode)),
    );
  }

  getProductsError(productCode: string, referenceType: string, categoryCode: string): Observable<boolean> {
    return this.store.pipe(
      select(ProductSelectors.getProductGroupReferencesError(productCode, referenceType, categoryCode)),
    );
  }

  resetProducts(): void {
    this.store.dispatch(new CustomProductActions.ProductGroupReferencesReset());
  }
}
